import * as React from "react";
// Controls
import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { Dismiss } from "@ms/planner-generic-controls/lib/local/icons";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * SensitivityMessageBar
 * This component displays a message bar in plan page which notifies user that plan has sensitivity label restrictions applied.
 * The message is shown when a plan's sensitivity label restricts editing permissions.
 */ export const SensitivityMessageBar = ({ onDismiss })=>{
    const [isVisible, setIsVisible] = React.useState(true);
    if (!isVisible) {
        return null;
    }
    const handleDismiss = ()=>{
        setIsVisible(false);
        onDismiss?.();
    };
    return /*#__PURE__*/ React.createElement(MessageBar, {
        "data-testid": "sensitivity-message-bar",
        role: "status",
        intent: "info"
    }, /*#__PURE__*/ React.createElement(MessageBarBody, null, /*#__PURE__*/ React.createElement(MessageBarTitle, null, Strings.SensitivityMessageBar_ViewOnlyTitle), Strings.SensitivityMessageBar_EditRestrictedMessage), /*#__PURE__*/ React.createElement(MessageBarActions, null, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "sensitivity-message-bar-button-dismiss",
        appearance: "transparent",
        icon: /*#__PURE__*/ React.createElement(Dismiss, null),
        onClick: handleDismiss,
        "aria-label": Strings.PlanHeader_MessageBar_DismissText_AriaLabel
    })));
};
